export default "__VITE_ASSET__Dc0y3AMm__"